/* eslint-disable no-unused-vars */
// CalendarioFull.jsx
import React, { useEffect, useState, useCallback } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import { Container, Box } from "@mui/system";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

import { obtenerCoordinaciones } from "../services/calendarioService";
import { getProfile } from "../../../modules/requerimiento/services/auth";
import {
  getRequerimiento,
  getPlacasPorServicioCliente,
  getUsuariosTrs,
  getTercializados,
  updateCoordinacion,
  updateRequerimiento,
} from "../../../modules/requerimiento/services/reqSolicitudes";
import RequerimientoDetalle from "../../../modules/requerimiento/pages/RequerimientoDetalle";

// colores por estado
const estadoColor = {
  "0": "#9e9e9e",
  "2": "#ffc107",
  "3": "#03a9f4",
  "7": "#dd8a7dff",
  "8": "#dad3d2ff",
};

// helper para normalizar placas
const normalizePlacas = (arr) =>
  Array.isArray(arr)
    ? Array.from(
        new Set(
          arr
            .map((s) => String(s || "").trim().toUpperCase())
            .filter(Boolean)
        )
      )
    : [];

export default function CalendarioFull() {
  // calendario
  const [events, setEvents] = useState([]);
  // diálogo
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCoord, setSelectedCoord] = useState(null);
  const [form, setForm] = useState({
    observacion: "",
    fecha: "",
    hora: "",
    lugar: "",
    contacto: "",
    telefono: "",
  });

  // formulario del dialog

  // placas
  const [placas, setPlacas] = useState([]);
  const [placaInput, setPlacaInput] = useState("");
  const [invalids] = useState([]);

  // técnicos
  const [tecnicos, setTecnicos] = useState([]);
  const [tecnicosSel, setTecnicosSel] = useState([]);

  // sucursal del requerimiento que se abrió en el dialog (para cargar técnicos)
  const [suc, setSuc] = useState("");

  // sucursal que se ve en el calendario (select)
  const [sucursalFiltro, setSucursalFiltro] = useState("La Paz");

  // banderas de requerimiento
  const [esAdicion, setEsAdicion] = useState(false);
  const [tercializado, setTercializado] = useState(false);
  const [tercOptions, setTercOptions] = useState([]);
  const [tercLoading, setTercLoading] = useState(false);
  const [tercSelected, setTercSelected] = useState(null);
  const [tercError, setTercError] = useState(false);

  // placas por cliente
  const [requierePlacasCliente, setRequierePlacasCliente] = useState(false);
  const [placasCliente, setPlacasCliente] = useState([]);
  const [placasClienteLoading, setPlacasClienteLoading] = useState(false);

  // data extra para pasar al dialog
  const [tipoRequerimiento, setTipoRequerimiento] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const [saving, setSaving] = useState(false);

  // <- NUEVO: loading del getRequerimiento
  const [loadingReq, setLoadingReq] = useState(false);
  const [codServicioBase, setCodServicioBase] = useState(null);
  /**
   * 1) función para cargar el calendario por sucursal
   */
  const loadCalendar = useCallback(async (sucursal) => {
    const sucUse = sucursal || "La Paz";
    const data = await obtenerCoordinaciones(sucUse);
    const eventosMapeados = data.map((item, i) => {
      const soloFecha = item.fecha.split("T")[0];
      const hora = item.hora || "08:00:00";
      return {
        id: item.id ?? i,
        title: `${item.tecnico || "Sin técnico"} - ${item.razon_social}`,
        start: `${soloFecha}T${hora}`,
        backgroundColor: estadoColor[item.estado] || item.color || "#2196f3",
        borderColor: estadoColor[item.estado] || item.color || "#2196f3",
        extendedProps: {
          ...item,
          soloFecha,
          hora,
        },
      };
    });
    setEvents(eventosMapeados);
  }, []);

  /**
   * 2) cargar una vez el perfil y primera tanda del calendario
   */
  useEffect(() => {
    const init = async () => {
      try {
        const user = await getProfile(); // { sucursal: "La Paz", ... }
        const sucUser = user?.sucursal || "La Paz";
        setSucursalFiltro(sucUser);
        await loadCalendar(sucUser);
      } catch (e) {
        await loadCalendar("La Paz");
      }
    };
    init();
  }, [loadCalendar]);

  /**
   * 3) cada vez que cambie la sucursal del requerimiento seleccionado,
   *    cargamos sus técnicos
   */
  /**
   * fetch de tercializados cuando estás en el dialog
   */
  const fetchTercializados = async (texto = "") => {
    if (!codServicioBase) return;
    try {
      setTercLoading(true);
      const { data } = await getTercializados(
        String(codServicioBase), 
        texto,
        20
      );
      setTercOptions(data || []);
    } finally {
      setTercLoading(false);
    }
  };

  /**
   * 4) cargar el requerimiento cuando haces click al evento
   */
  const loadRequerimiento = useCallback(async (cod) => {
    setLoadingReq(true); // <- empieza cargando
    try {
      const { data } = await getRequerimiento(cod);

      // guardo extras
      setTipoRequerimiento(data?.nombre_ot_tipo || "");
      setRazonSocial(data?.razon_social || "");
      setDescripcion(data?.descripcion || "");

      // form base
      setForm((prev) => ({
        ...prev,
        observacion: data?.obs2 || data?.observacion || prev.observacion,
        fecha: data?.fecha_cordinacion
          ? new Date(data.fecha_cordinacion).toISOString().slice(0, 10)
          : prev.fecha,
        hora: data?.hora_cordinacion
          ? String(data.hora_cordinacion).slice(0, 5)
          : prev.hora,
        lugar: data?.lugar || prev.lugar,
        contacto: data?.contacto || prev.contacto,
        telefono: data?.telefono || prev.telefono,
      }));

      // técnicos ya seleccionados
      const tecCsv = (data?.tecnico || "")
        .split(/[,]+/g)
        .map((s) => s.trim())
        .filter(Boolean);
      setTecnicosSel(tecCsv);

      // placas
      const placasCsv = (data?.placa || "")
        .split(/[,;\s]+/g)
        .filter(Boolean);
      const placasNorm = normalizePlacas(placasCsv);
      setPlacas(placasNorm);

      // placas del cliente
      if (data?.cod_servicio_cliente) {
        setCodServicioBase(data.cod_servicio_cliente);
        setRequierePlacasCliente(true);
        setPlacasClienteLoading(true);
        try {
          const { data: respPlacas } = await getPlacasPorServicioCliente(
            data.cod_servicio_cliente
          );
          const placasOpts = normalizePlacas(respPlacas);
          setPlacasCliente(placasOpts);
          // si no tenía placas, uso las del cliente
          //if (!placasNorm.length && placasOpts.length) {
          //  setPlacas(placasOpts);
          //}
        } finally {
          setPlacasClienteLoading(false);
        }
      } else {
        setRequierePlacasCliente(false);
        setPlacasCliente([]);
        setCodServicioBase(null);
      }

      // tercializado
      const flagTerc =
        data?.tercializado === 1 ||
        data?.tercializado === "1" ||
        data?.tercializado === true ||
        data?.tercia ||
        data?.cod_servicio_cliente_tercializado;

      const esAdd = /adici/i.test(String(data?.nombre_ot_tipo || ""));
      setEsAdicion(esAdd);

      setTercializado(!!flagTerc);
      if (flagTerc) {
        const idTerc =
          data?.tercia || data?.cod_servicio_cliente_tercializado || null;
        if (idTerc) {
          setTercSelected({
            cod_servicio: String(idTerc),
            razon_social: data?.razon_social_tercializado || `#${idTerc}`,
          });
        }
      }

      // sucursal del requerimiento (para cargar técnicos)
      setSuc(data?.sucursal || "");
      if (data?.sucursal) {
        const resTec = await getUsuariosTrs({
          role: "tecnico",
          sucursal: data.sucursal,
        });
        setTecnicos(
          resTec.data.map((t) => ({
            username: t.username,
            nombre: t.nombre,
            sucursal: t.sucursal,
          }))
        );
      }
    } catch (err) {
      console.error("Error getRequerimiento desde calendario", err);
    } finally {
      setLoadingReq(false); // <- termina cargando
    }
  }, []);

  /**
   * 5) click en un evento del calendario
   */
  const handleEventClick = (clickInfo) => {
    const evt = clickInfo.event.extendedProps;
    setSelectedCoord(evt);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setSelectedCoord(null);
  };

  /**
   * 6) guardar cambios del dialog
   */
  const handleSave = async () => {
    if (!selectedCoord) {
      setOpenDialog(false);
      return;
    }

    const placaCSV = placas.map((p) => p.trim()).filter(Boolean).join(",");
    const tecnicosCSV = tecnicosSel
      .map((t) => t.trim())
      .filter(Boolean)
      .join(", ");

    const payloadCoord = {
      placa: placaCSV,
      tecnico: tecnicosCSV,
      observacion: form.observacion || "",
      fecha: form.fecha || "",
      hora: form.hora || "",
      lugar: form.lugar || "",
      contacto: form.contacto || "",
      telefono: form.telefono || "",
    };

    setSaving(true);
    try {
      const promises = [];

      if (selectedCoord.id) {
        promises.push(updateCoordinacion(selectedCoord.id, payloadCoord));
      }

      if (esAdicion && tercializado && tercSelected && selectedCoord.cod) {
        promises.push(
          updateRequerimiento(selectedCoord.cod, {
            tercia: Number(tercSelected.cod_servicio),
          })
        );
      }

      await Promise.all(promises);

      // recargo usando la sucursal que está en el select
      await loadCalendar(sucursalFiltro);

      setOpenDialog(false);
    } catch (e) {
      console.error("No se pudo actualizar la coordinación desde calendario", e);
    } finally {
      setSaving(false);
    }
  };

  const estadoInfo = {
    label: selectedCoord ? `Estado ${selectedCoord.estado}` : "Estado —",
  };

  return (
    <Container maxWidth={false} >
      {/* Selector de sucursal */}
      <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Coordinaciones por sucursal
        </Typography>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel id="sucursal-label">Sucursal</InputLabel>
          <Select
            labelId="sucursal-label"
            label="Sucursal"
            size="small"
            value={sucursalFiltro}
            onChange={async (e) => {
              const nueva = e.target.value;
              setSucursalFiltro(nueva);
              await loadCalendar(nueva);
            }}
          >
            <MenuItem value="La Paz">La Paz</MenuItem>
            <MenuItem value="Cochabamba">Cochabamba</MenuItem>
            <MenuItem value="Santa Cruz">Santa Cruz</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Calendario */}
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        events={events}
        eventClick={handleEventClick}
        height="auto"
        locale={esLocale}
        buttonText={{
          today: "Hoy",
          month: "Mes",
          week: "Semana",
          day: "Día",
        }}
      />

      {/* Dialog de edición */}
      {selectedCoord && (
        <Dialog
          open={openDialog}
          onClose={handleClose}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 1.25,
              maxHeight: "92vh",
              bgcolor: "background.paper",
              color: "text.primary",
            },
          }}
        >
          <DialogTitle
            sx={{
              py: 1,
              fontSize: "0.95rem",
              fontWeight: 900,
              bgcolor: "background.paper",
              color: "text.primary",
            }}
          >
            Requerimiento #{selectedCoord.cod}
            <Typography variant="caption" sx={{ display: "block", color: "text.secondary" }}>
              {selectedCoord.razon_social || selectedCoord.title || ""}
            </Typography>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              p: 1,
              bgcolor: "background.default",
              color: "text.primary",
            }}
          >
            <RequerimientoDetalle
              codProp={selectedCoord.cod}
              embedded
              onBack={handleClose}
            />
          </DialogContent>
          <DialogActions sx={{ p: 0.75, bgcolor: "background.paper" }}>
            <Button size="small" onClick={handleClose}>
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  );
}
